import {Directive, ElementRef, OnInit} from '@angular/core';

@Directive({
    selector: '[appAutocomplete]',
    standalone: false
})
export class AutocompleteDirective implements OnInit {

  private element: HTMLInputElement;

  constructor(elRef: ElementRef) {
    this.element = elRef.nativeElement;
  }

  ngOnInit(): void {
    this.element.setAttribute('autocomplete', 'new-value'); // this will override default autocomplete.
  }

}
